import React from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseButton from "../../components/BaseButton";
import useModalActions from "../../hooks/useModalActions";
import useController from "./controller";
import { useTranslation } from "react-i18next";

export default function RemoveGame() {
  const { closeModal } = useModalActions();
  const { onPayload, removeGame, gameIsDeleting } = useController();
  const { t } = useTranslation();

  return (
    <BaseModal
      onPayload={onPayload}
      title={t("modals.remove_game.title")}
      className="remove-game-modal"
      eventTypeModal={MODAL_TYPES.REMOVE_GAME}
    >
      <BaseButton
        loading={gameIsDeleting}
        typeSpinner="light"
        onClick={removeGame}
      >
        {t("modals.remove_game.remove")}
      </BaseButton>
      <BaseButton
        unfilledWhite
        className="modal-button-cancel"
        onClick={() => closeModal(MODAL_TYPES.REMOVE_GAME)}
      >
        {t("modals.remove_game.cancel")}
      </BaseButton>
    </BaseModal>
  );
}
